module.exports = __webpack_public_path__ + "img/icon_weak_content.68560917.png";